var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heading-container"},[_c('div',{staticClass:"text-container"},[_c('img',{staticClass:"text-icon",attrs:{"src":_vm.icon,"alt":_vm.iconAlt}}),_c('h2',{staticClass:"text"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }